// Sends a photo to our backend OCR proxy (Google Cloud Vision's
// DOCUMENT_TEXT_DETECTION, hinted for Japanese) - see utils/ocr.ts for why
// the client-side Tesseract path alone wasn't accurate enough on real-world
// photographed text (stylized fonts, uneven lighting, camera noise), and
// for the fallback that kicks in when this endpoint isn't available.
import { resizeAndEncodeAsJpeg } from "./imageEncoding";

const PUBLIC_API_URL = "https://d29a52ery9.execute-api.us-east-1.amazonaws.com/prod";
const OCR_URL = `${PUBLIC_API_URL}/ocr`;

export interface CloudOcrResult {
    text: string;
    confidence: number;
}

export async function recognizeJapaneseTextViaCloud(source: File | Blob): Promise<CloudOcrResult> {
    const imageBase64 = await resizeAndEncodeAsJpeg(source);

    const response = await fetch(OCR_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ image: imageBase64 }),
    });
    if (!response.ok) throw new Error(`Cloud OCR request failed (${response.status})`);

    const data = await response.json();
    if (typeof data.text !== "string") throw new Error("Malformed OCR response");

    return { text: data.text, confidence: typeof data.confidence === "number" ? data.confidence : 0 };
}
